import React from 'react';
import { cn } from '@/lib/utils';

interface SectionCardProps {
  title: React.ReactNode;
  icon?: React.ElementType;
  actions?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
  contentClassName?: string;
}

/**
 * SectionCard — Componente oficial do Design System NetUno.
 * Uso obrigatório para seções de dashboard com título + conteúdo.
 * Proibido criar cards com título manual fora deste componente.
 */
export const SectionCard: React.FC<SectionCardProps> = ({
  title,
  icon: Icon,
  actions,
  children,
  className,
  contentClassName,
}) => (
  <div className={cn('emp-card p-5 flex flex-col min-h-0', className)}>
    <div className="flex items-center justify-between mb-3 flex-shrink-0">
      <h3 className="emp-section-title flex items-center gap-2">
        {Icon && <Icon className="h-4 w-4" strokeWidth={1.5} />}
        {title}
      </h3>
      {actions && <div className="flex items-center gap-1.5">{actions}</div>}
    </div>
    <div className={cn('flex-1 min-h-0', contentClassName)}>
      {children}
    </div>
  </div>
);

export default SectionCard;
